import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GenerateReportRequest,
	GetReportsLastDatesRequest
} from '../requests/ReportsRequests.js';

export const GET_REPORTS_LAST_DATES = 'GET_REPORTS_LAST_DATES';

const onGetReportsLastDates = (value) => ({
	type: GET_REPORTS_LAST_DATES,
	reportsLastDates: value
});

export const GetReportsLastDates = () => async (dispatch) => {
	await GetReportsLastDatesRequest().then(response => {
		dispatch(onGetReportsLastDates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateReport = (filters) => async (dispatch) => {
	await GenerateReportRequest(filters).then(response => {
		if (response.data === '') {
			dispatch(enqueueSnackbar({ message: 'Your request is being processed. Your file will be available on Downloads soon.', options: { variant: 'info' } }));
		} else {
			dispatch(DownloadFile(response.data));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
